<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view/>
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>
<script>

import { FadeTransition } from 'vue2-transitions'

export default {
  components: {
    FadeTransition

  }
}
</script>
<style lang="sass">

  .tooltip
    display: block !important
    z-index: 10000

    .tooltip .tooltip-inner
      background: #cce5ff
      color: #004085
      border-radius: 16px
      padding: 5px 10px 4px

    .tooltip .tooltip-arrow
      width: 0
      height: 0
      border-style: solid
      position: absolute
      margin: 5px
      border-color: #cce5ff
      z-index: 1

    .tooltip[x-placement^="top"]
      margin-bottom: 5px

    .tooltip[x-placement^="top"] .tooltip-arrow
      border-width: 5px 5px 0 5px
      border-left-color: transparent !important
      border-right-color: transparent !important
      border-bottom-color: transparent !important
      bottom: -5px
      left: calc(50% - 5px)
      margin-top: 0
      margin-bottom: 0

    .tooltip[x-placement^="bottom"]
      margin-top: 5px

    .tooltip[x-placement^="bottom"] .tooltip-arrow
      border-width: 0 5px 5px 5px
      border-left-color: transparent !important
      border-right-color: transparent !important
      border-top-color: transparent !important
      top: -5px
      left: calc(50% - 5px)
      margin-top: 0
      margin-bottom: 0

    .tooltip[x-placement^="right"]
      margin-left: 5px

    .tooltip[x-placement^="right"] .tooltip-arrow
      border-width: 5px 5px 5px 0
      border-left-color: transparent !important
      border-top-color: transparent !important
      border-bottom-color: transparent !important
      left: -5px
      top: calc(50% - 5px)
      margin-left: 0
      margin-right: 0

    .tooltip[x-placement^="left"]
      margin-right: 5px

    .tooltip[x-placement^="left"] .tooltip-arrow
      border-width: 5px 0 5px 5px
      border-top-color: transparent !important
      border-right-color: transparent !important
      border-bottom-color: transparent !important
      right: -5px
      top: calc(50% - 5px)
      margin-left: 0
      margin-right: 0

    .tooltip.popover .popover-inner
      background: #f9f9f9
      color: #cce5ff
      padding: 24px
      border-radius: 5px
      box-shadow: 0 5px 30px rgba(#cce5ff, .1)

    .tooltip.popover .popover-arrow
      border-color: #f9f9f9

    .tooltip[aria-hidden='true']

      visibility: hidden
      opacity: 0

      transition: opacity .15s, visibility .15s

    .tooltip[aria-hidden='false']

      visibility: visible
      opacity: 1

      transition: opacity 0.15s

</style>
